<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="contactEmailForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                contactEmailForm: () => import('../forms/ContactEmailForm'),
                headers: [
                    { text: 'Contact', value: 'contactId', table: 'contacts', form: () => import('../forms/ContactForm') },
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    contacts: [],
                    items: []
                },
                sorting: [
                    { column: "emailAddress", direction: "ascending" },
                    { column: "contactId", direction: "ascending" },
                ],
                itemsField: 'contactEmails',
                editPageName: 'contactEmail',
                apiMethod: 'ContactEmails',
                claimName: 'ContactEmails',
                formTitle: 'Contact Email',
                excelTitle: 'Contact Emails',
                hasEditPage: false,
            }
        },
    };
</script>
